import React from "react";
import SurveyTitleComp from "./SurveyTitleComp";

export default function SurveyGroupComp({field, onSubmit}) {
    return (
        <SurveyTitleComp field={field}
                         onSubmit={()=>onSubmit(null)}
                         submitDisabled={false}
        />)
}